import PropTypes from 'prop-types';
import React from 'react';

import ColorwayPicker, { NAV_SIZES } from 'components/ColorwayPicker';
import { mediumUp } from 'constants/mediaQueries';
import CartUpsell from 'models/CartUpsell';
import Theme from 'styles/theme';
import { buildColorwayPickerSlides } from 'utils/Upsells';

const ColorSwatchCarousel = ({
  recommendedItems,
  handleSwatchSelect,
  activeColorwayHandle,
  slideIndex,
  handleSlideIncrement,
  handleSlideDecrement,
  isMobile,
}) => {
  const getSlides = () => {
    return isMobile === true
      ? buildColorwayPickerSlides(recommendedItems, 5)
      : buildColorwayPickerSlides(recommendedItems);
  };

  const getNavSize = () => {
    return isMobile === true ? NAV_SIZES.SMALL : NAV_SIZES.MEDIUM;
  };

  const getDiameter = () => {
    return isMobile === true ? Theme.get('spacing') * 3.5 : Theme.get('spacing') * 4;
  };

  return (
    <div className="ColorSwatchCarousel">
      <ColorwayPicker
        className="ColorSwatchCarousel__color-picker"
        slides={getSlides()}
        currentSlideIndex={slideIndex}
        onSwatchSelect={handleSwatchSelect}
        activeColorwayHandle={activeColorwayHandle}
        diameter={getDiameter()}
        navSize={getNavSize()}
        key={getSlides().length}
        onSlideIndexIncrement={handleSlideIncrement}
        onSlideIndexDecrement={handleSlideDecrement}
      />
      <style jsx>
        {`
          .ColorSwatchCarousel {
            margin-left: ${Theme.get('spacing') / 2}px;
          }
        `}
      </style>
      <style jsx global>
        {`
          .ColorSwatchCarousel__color-picker.ColorwayPicker {
            max-width: ${Theme.get('spacing') * 26}px;
            margin-top: ${Theme.get('spacing') / 2}px;
            margin-left: -${Theme.get('spacing') * 2}px;
            height: 100%;
          }

          @media ${mediumUp} {
            .ColorSwatchCarousel__color-picker.ColorwayPicker {
              max-width: ${Theme.get('spacing') * 42}px;
            }
          }

          .ColorSwatchCarousel__color-picker .ColorwayPicker__item.ColorwayPicker__item--nav {
            background-color: ${Theme.get('colors-grey')};
          }
        `}
      </style>
    </div>
  );
};

ColorSwatchCarousel.propTypes = {
  recommendedItems: PropTypes.arrayOf(PropTypes.instanceOf(CartUpsell)).isRequired,
  activeColorwayHandle: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  handleSwatchSelect: PropTypes.func,
  slideIndex: PropTypes.number,
  handleSlideIncrement: PropTypes.func,
  handleSlideDecrement: PropTypes.func,
};

ColorSwatchCarousel.defaultProps = {
  isMobile: false,
  slideIndex: 0,
  handleSwatchSelect: () => {},
  handleSlideIncrement: () => {},
  handleSlideDecrement: () => {},
};

export default ColorSwatchCarousel;
